export default "__VITE_PUBLIC_ASSET__391ed3f6__"